


























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import { DxButton, DxPopup, DxLookup, DxSelectBox, DxTextBox, DxCheckBox, DxScrollView, DxTooltip } from 'devextreme-vue';
import DxToolbar from 'devextreme-vue/toolbar'
import { DxForm, DxItem, DxAsyncRule, DxStringLengthRule,DxSimpleItem } from 'devextreme-vue/form';
import CustomStore from 'devextreme/data/custom_store';
import { AgentService } from '../../service/AgentService';
import { ClientDto } from '@/models/client/ClientDto';
import { FeeSheetDto } from '@/models/Fees/FeeSheetDto';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { FilingTypeDto } from '@/models/FilingTypeDto';
import { CurrencyService } from '@/service/CurrencyService';
import { JurisdictionDto } from '@/models/JurisdictionDto';
import Form from "devextreme/ui/form";
import { FeeSheetsService } from '@/service/FeeSheetsService';
import { FeeSheetModalFor, FeeSheetModalType } from '@/models/Fees/FeeTypeEnum';
import _ from "lodash";
import { PhaseTypeService } from '@/service/PhaseTypeService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFormItem,
  DxHeaderFilter,
  DxScrolling
} from 'devextreme-vue/data-grid';
import { DxDateBox , DxTagBox} from 'devextreme-vue';
import DxList from 'devextreme-vue/list';
import DxListItem from 'devextreme-vue/list';
import DevExpress from 'devextreme';
import { PhaseTypeDto } from '../../models/PhaseTypeDto';
import { FeeSheetRowDto, FeeSheetRowTypeEnum } from '../../models/Fees/FeeSheetRowDto';
import { FeeSheetRuleDto, FeeSheetRuleTypeEnum, FeeSheetRuleLevelEnum, FeeSheetRulesSortFunction } from '../../models/Fees/FeeSheetRuleDto';
import { InfractionTypeDto } from '../../models/infractions/InfractionTypeDto';
import { Popup } from '@questelservices/common-vue';
import { AgentDto } from '../../models/agent/AgentDto';
import { FeeSheetMassAdderDto, FeeSheetMassAdderCreationDto } from '../../models/Fees/FeeSheetMassAdderDto';
import { alert } from "devextreme/ui/dialog";
import DataSource from 'devextreme/data/data_source';
import List from "devextreme/ui/list";
import { DxValidator, DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import DxValidationGroup from 'devextreme-vue/validation-group';
import ValidationGroup from "devextreme/ui/validation_group";

@Component({
  components: {
    Popup,    
    DxButton,
    DxLookup,
    DxScrollView,
    DxSelectBox,
    DxToolbar,
    DxToolbarItem,        
    DxList,
    DxListItem,
    DxDateBox,
    DxTagBox,
    DxTooltip,
    DxValidationGroup,
    DxValidator, DxRequiredRule, DxCustomRule
  }
})
export default class AgentFeeSheetMassAdder extends Vue {
    $refs: Vue['$refs'] & {      
        agentSelectionRef? : List;
        validationGroupRef? : ValidationGroup;
    } = {};

    get AgentSelectionComponent()  {
        return ((this.$refs.agentSelectionRef as any).instance as any);
    }

    @Prop({ default: false })
    showDialog!: boolean;

    @Prop()
    selectedClient!: ClientDto;

    @Prop()
    clientAgents! : Guid[];

    get ClientAgents() :  Guid[] {
        return this.clientAgents;
    }

    get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any)
    }

    hoveredItem : string = "";
    tooltipVisible: boolean = false;
    agentGroup: string = '';
    preSelectedAgentIds: Guid[] = []
    feeSheetService: FeeSheetsService;
    clientFeeSheets: FeeSheetDto[] = [];
    selectedEffectiveDate: any = null;
    selectedFeeSheetId: Guid = "";

    // agentList: AgentDto[] = []
    get AgentSelectionStore() : DataSource {
        return new DataSource({
            store: this.AgentCustomStore,
            paginate: true,
            pageSize: 50,
            key: "Agent.AgentId"
        });
    }
    get AgentCustomStore() : CustomStore {
        return new CustomStore({      
            loadMode: 'raw',      
            load: (options): Promise<any> => {
                    return this.agentService.getAll()
                    .then(this.processResult)
                    .catch(err => err);
                
                
            }
        });
    }

    processResult(result: any) {
        let res = result.map((item: any) => {
                            return {
                                Agent : item,
                                IsClientAgent : this.clientAgents.includes(item.AgentId),
                                AgentFeeSheetExists : this.preSelectedAgentIds.includes(item.AgentId)
                            }
                        })
        return _.orderBy(res, item => item.IsClientAgent, ['desc']);
    }
    private agentService = new AgentService();


    agentListItems: any = [];
    selectedAgentIds: Guid[] = [];

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value:boolean) {
        this.hidingDialog();
    }


    get getTitle() {
        if(this.selectedClient) {
            return "Create Agent Fee Sheets for " + this.selectedClient.ClientName;
        }
        //fallback Title in case
        return "Create Agent Fee Sheets";
    }

    constructor() {
        super();
        this.feeSheetService = new FeeSheetsService('/api/FeeSheets');   
    }
    tagItemStyle(e:any) {
        return {
            'padding-left' : '8px',
            'padding-top' : '5px',
            'padding-bottom' : '5px',
            'padding-right' : this.preSelectedAgentIds.includes(e.Agent.AgentId) ? '10px' : '32px'
        }
    }
    validateSelectAgents(e:any) {
        if(e.value && e.value.length > 0){
            if(_.every(e.value, x => this.preSelectedAgentIds.includes(x))) {
                return false;
            }
        }
        
        return true;
    }
    onMouseEnter(e: any) {
        this.tooltipVisible = true;
        this.hoveredItem = '#item-' + e.Agent.AgentId;
        this.agentGroup = e.IsClientAgent ? "Client Agent" : "Other Agent";
    }
    onMouseLeave() {
        this.tooltipVisible = false;
        this.hoveredItem = '';
        this.agentGroup = '';
    }

    onOpened(e: any) {
        let element = document.getElementsByClassName("dx-list-select-all")[0] as any;
        if (element != null) {
          element.remove();
        }
    }
    
    async loadData() {
        let clientFeeSheets = await this.feeSheetService.getFeeSheetPerClient(this.selectedClient.ClientId);
        this.clientFeeSheets = clientFeeSheets.filter(fs => fs.AgentId == null);
    }

    async onSelectedFeeSheetChanged() {
        if (this.selectedFeeSheetId === null) {
            return;
        }

        this.selectedAgentIds = [];
        this.preSelectedAgentIds = await this.feeSheetService.getAgentsWithParentFeeSheet(this.selectedFeeSheetId)
             .then(result => result)
             .catch(err=> []);
        this.selectedAgentIds = _.cloneDeep(this.preSelectedAgentIds);
        
        this.AgentSelectionStore.load();
    }

    onPopupHidden(e:any) {
        this.preSelectedAgentIds = [];
        this.selectedAgentIds = [];
        this.selectedFeeSheetId = '';
        this.selectedEffectiveDate = null;

        this.validationGroup.reset();

    }
    async onPopupShowing(e:any) {
        this.agentListItems = [];   

        this.AgentSelectionStore.reload();
        await this.loadData();
        this.validationGroup.reset();
    }

    save() {   
        if(!this.showingDialog) {
            return;
        }

        let validate = this.validationGroup.validate();
        
        if(!validate.isValid){
            return;
        }

        let creationDto: FeeSheetMassAdderCreationDto =
        {
            Agents: this.selectedAgentIds.filter(x => !this.preSelectedAgentIds.includes(x))
                .map(id => {
                    return  {
                        AgentId : id,
                        AgentName : ""
                    }
                }),
            EffectiveDate: this.selectedEffectiveDate
        };

        this.feeSheetService.createAgentFeeSheetsFromList(this.selectedFeeSheetId, creationDto)
            .then(result => {
                this.hidingDialog();
            });        
    }

    hidingDialog() {
        this.$emit("hidingMassAdder");
    }
}
